import PapaParse from 'papaparse'

const saveCsv = (data: any, filename: any, columns?: any) => {
  const link = window.document.createElement('a')
  link.href = window.URL.createObjectURL(
    new Blob([PapaParse.unparse(data, { escapeFormulae: true, ...(columns && { columns }) })], { type: 'text/csv' })
  )
  link.download = filename

  // Append anchor to body.
  document.body.append(link)
  link.click()

  // Remove anchor from body
  link.remove()
}

const saveTemplate = (data: any, filename = 'template.csv') => {
  saveCsv(data, filename)
}

export { saveCsv, saveTemplate }
